/**
 * Build the public Guest Portal URL for a given property code.
 *
 * Hosting layout:
 *   - Local dev: staff frontend runs on its own port (e.g. :3001), guest
 *     portal runs on :3002 (`npx serve -s build -l 3002`).
 *   - UAT / Prod: served behind one nginx vhost — guest portal is mounted
 *     under `/guest-portal/` (alias to the static build folder).
 *
 * Heuristic: if window.location.origin has a port suffix, we're in local
 * dev and should swap the port to 3002. Otherwise we're on a hosted
 * environment and should use the `/guest-portal/` path on the same origin.
 */
export function buildGuestPortalUrl(propertyCode) {
  if (!propertyCode) return '';
  if (typeof window === 'undefined' || !window.location) return '';
  const origin = window.location.origin;
  const code = encodeURIComponent(propertyCode);
  const hasPort = /:\d+$/.test(origin);
  if (hasPort) {
    return `${origin.replace(/:\d+$/, ':3002')}/?code=${code}`;
  }
  return `${origin}/guest-portal/?code=${code}`;
}
